import { render, staticRenderFns } from "./ScrollingFooter.vue?vue&type=template&id=bd366944&scoped=true&"
import script from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
export * from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollingFooter.vue?vue&type=style&index=0&id=bd366944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd366944",
  null
  
)

export default component.exports